/**
 * MotoMachina Theme - Main JavaScript
 * Search Modal, Product Cards, Cart Drawer, Quick View, Wishlist
 */

(function() {
  'use strict';

  // ===== SEARCH MODAL =====
  var searchModal = document.getElementById('search-modal');
  var searchInput = document.getElementById('search-modal-input');
  var searchResults = document.querySelector('[data-search-results]');
  var searchTimeout = null;
  var selectedIndex = -1;

  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { if (searchInput) searchInput.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('is-open');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    selectedIndex = -1;
    if (searchResults) {
      searchResults.innerHTML = '<div class="search-modal__empty"><i class="fa-solid fa-motorcycle"></i><p>Start typing to search</p><span>Find helmets, gear, accessories & more</span></div>';
    }
  }

  function toggleSearch() {
    if (searchModal && searchModal.classList.contains('is-open')) {
      closeSearch();
    } else {
      openSearch();
    }
  }

  function updateSearchSelection(results) {
    results.forEach(function(r, i) {
      r.classList.toggle('is-selected', i === selectedIndex);
      if (i === selectedIndex) {
        r.scrollIntoView({ block: 'nearest' });
      }
    });
  }

  // Search keyboard shortcuts
  document.addEventListener('keydown', function(e) {
    // Ctrl+K or Cmd+K to toggle
    if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
      e.preventDefault();
      toggleSearch();
    }
    // Escape to close search
    if (e.key === 'Escape' && searchModal && searchModal.classList.contains('is-open')) {
      closeSearch();
    }
    // Arrow navigation in search
    if (searchModal && searchModal.classList.contains('is-open') && searchResults) {
      var results = searchResults.querySelectorAll('.search-modal__result');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        selectedIndex = Math.min(selectedIndex + 1, results.length - 1);
        updateSearchSelection(results);
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        selectedIndex = Math.max(selectedIndex - 1, 0);
        updateSearchSelection(results);
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        if (selectedIndex >= 0 && results[selectedIndex]) {
          window.location.href = results[selectedIndex].href;
        } else if (searchInput && searchInput.value.trim().length >= 2) {
          window.location.href = '/search?q=' + encodeURIComponent(searchInput.value.trim());
        }
      }
    }
  });

  // Search close button
  var searchCloseBtn = document.querySelector('[data-search-close]');
  if (searchCloseBtn) {
    searchCloseBtn.addEventListener('click', closeSearch);
  }

  // Search icon click
  document.querySelectorAll('.header__icon[aria-label="Search"]').forEach(function(icon) {
    icon.addEventListener('click', function(e) {
      e.preventDefault();
      openSearch();
    });
  });

  // Search input
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function() {
      var query = this.value.trim();
      clearTimeout(searchTimeout);

      if (query.length < 2) {
        searchResults.innerHTML = '<div class="search-modal__empty"><i class="fa-solid fa-motorcycle"></i><p>Start typing to search</p><span>Find helmets, gear, accessories & more</span></div>';
        selectedIndex = -1;
        return;
      }

      searchResults.innerHTML = '<div class="search-modal__loading"><i class="fa-solid fa-spinner"></i></div>';

      searchTimeout = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,page&resources[limit]=8')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            selectedIndex = -1;
            var html = '';
            var resources = data.resources.results;

            // Products
            if (resources.products && resources.products.length > 0) {
              html += '<div class="search-modal__group">';
              html += '<div class="search-modal__group-title">Products</div>';
              html += '<div class="search-modal__results">';
              resources.products.forEach(function(product) {
                var img = product.featured_image ? product.featured_image.url : '';
                var price = product.price ? '₹' + parseFloat(product.price).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
                html += '<a href="' + product.url + '" class="search-modal__result">';
                if (img) {
                  html += '<img src="' + img + '&width=100" alt="" class="search-modal__result-image">';
                } else {
                  html += '<div class="search-modal__result-icon"><i class="fa-solid fa-box"></i></div>';
                }
                html += '<div class="search-modal__result-content">';
                html += '<div class="search-modal__result-title">' + product.title + '</div>';
                html += '<div class="search-modal__result-meta">' + (product.vendor || '') + '</div>';
                html += '</div>';
                if (price) html += '<div class="search-modal__result-price">' + price + '</div>';
                html += '<i class="fa-solid fa-chevron-right search-modal__result-arrow"></i>';
                html += '</a>';
              });
              html += '</div></div>';
            }

            // Collections
            if (resources.collections && resources.collections.length > 0) {
              html += '<div class="search-modal__group">';
              html += '<div class="search-modal__group-title">Collections</div>';
              html += '<div class="search-modal__results">';
              resources.collections.forEach(function(col) {
                html += '<a href="' + col.url + '" class="search-modal__result">';
                html += '<div class="search-modal__result-icon"><i class="fa-solid fa-layer-group"></i></div>';
                html += '<div class="search-modal__result-content">';
                html += '<div class="search-modal__result-title">' + col.title + '</div>';
                html += '</div>';
                html += '<i class="fa-solid fa-chevron-right search-modal__result-arrow"></i>';
                html += '</a>';
              });
              html += '</div></div>';
            }

            // Pages
            if (resources.pages && resources.pages.length > 0) {
              html += '<div class="search-modal__group">';
              html += '<div class="search-modal__group-title">Pages</div>';
              html += '<div class="search-modal__results">';
              resources.pages.forEach(function(page) {
                html += '<a href="' + page.url + '" class="search-modal__result">';
                html += '<div class="search-modal__result-icon"><i class="fa-solid fa-file-lines"></i></div>';
                html += '<div class="search-modal__result-content">';
                html += '<div class="search-modal__result-title">' + page.title + '</div>';
                html += '</div>';
                html += '<i class="fa-solid fa-chevron-right search-modal__result-arrow"></i>';
                html += '</a>';
              });
              html += '</div></div>';
            }

            if (!html) {
              html = '<div class="search-modal__no-results"><i class="fa-solid fa-face-sad-tear"></i><p>No results found for "' + query + '"</p></div>';
            }

            searchResults.innerHTML = html;
          })
          .catch(function() {
            searchResults.innerHTML = '<div class="search-modal__no-results"><i class="fa-solid fa-triangle-exclamation"></i><p>Something went wrong. Try again.</p></div>';
          });
      }, 300);
    });
  }

  // ===== PRODUCT CARD THUMBNAIL CLICK =====
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;

    e.preventDefault();
    e.stopPropagation();

    var card = thumb.closest('[data-product-card]');
    if (!card) return;

    var mainImage = card.querySelector('[data-main-image]');
    var thumbs = card.querySelectorAll('[data-thumb]');
    var newUrl = thumb.dataset.imageUrl;

    if (mainImage && newUrl && mainImage.src !== newUrl) {
      mainImage.classList.add('is-loading');
      var preloader = new Image();
      preloader.onload = function() {
        mainImage.src = newUrl;
        mainImage.classList.remove('is-loading');
      };
      preloader.onerror = function() {
        mainImage.classList.remove('is-loading');
      };
      preloader.src = newUrl;

      thumbs.forEach(function(t) { t.classList.remove('product-card__thumb--active'); });
      thumb.classList.add('product-card__thumb--active');
    }
  });

  // ===== CART DRAWER =====
  var drawer = document.getElementById('cart-drawer');
  if (drawer) {
    var undoToast = drawer.querySelector('[data-cart-undo]');
    var undoTitle = drawer.querySelector('[data-undo-title]');
    var undoTimeout = null;
    var lastRemovedItem = null;

    function showUndoToast(title, variantId) {
      lastRemovedItem = { title: title, variantId: variantId };
      if (undoTitle) undoTitle.textContent = title + ' removed';
      if (undoToast) undoToast.classList.add('is-visible');
      clearTimeout(undoTimeout);
      undoTimeout = setTimeout(hideUndoToast, 5000);
    }

    function hideUndoToast() {
      if (undoToast) undoToast.classList.remove('is-visible');
      clearTimeout(undoTimeout);
      lastRemovedItem = null;
    }

    function undoRemove() {
      if (!lastRemovedItem) return;
      hideUndoToast();
      window.addToCart(lastRemovedItem.variantId, 1);
    }

    // Undo button events
    if (undoToast) {
      var undoBtn = undoToast.querySelector('[data-undo-btn]');
      var undoClose = undoToast.querySelector('[data-undo-close]');
      if (undoBtn) undoBtn.addEventListener('click', undoRemove);
      if (undoClose) undoClose.addEventListener('click', hideUndoToast);
    }

    // ===== DISCOUNT CODE FUNCTIONALITY =====
    var discountSection = drawer.querySelector('[data-discount-section]');
    var discountToggle = drawer.querySelector('[data-discount-toggle]');
    var discountInput = drawer.querySelector('[data-discount-input]');
    var discountApply = drawer.querySelector('[data-discount-apply]');
    var discountMessage = drawer.querySelector('[data-discount-message]');
    var discountApplied = drawer.querySelector('[data-discount-applied]');
    var discountCodeEl = drawer.querySelector('[data-discount-code]');
    var discountAmountEl = drawer.querySelector('[data-discount-amount]');
    var discountRemove = drawer.querySelector('[data-discount-remove]');
    var appliedDiscountCode = localStorage.getItem('moto_discount_code') || null;

    // Toggle discount form visibility
    if (discountToggle && discountSection) {
      discountToggle.addEventListener('click', function() {
        discountSection.classList.toggle('is-open');
        if (discountSection.classList.contains('is-open') && discountInput) {
          setTimeout(function() { discountInput.focus(); }, 150);
        }
      });
    }

    // Apply discount code
    function applyDiscountCode(code) {
      if (!code || !code.trim()) return;
      code = code.trim().toUpperCase();

      if (discountApply) {
        discountApply.disabled = true;
        discountApply.textContent = '...';
      }
      if (discountMessage) {
        discountMessage.textContent = '';
        discountMessage.className = 'cart-drawer__discount-message';
      }

      // Store discount code in localStorage (Shopify applies at checkout via URL param)
      localStorage.setItem('moto_discount_code', code);
      appliedDiscountCode = code;

      // Update UI to show applied discount
      if (discountInput) discountInput.value = '';
      if (discountApplied) discountApplied.style.display = 'flex';
      if (discountCodeEl) discountCodeEl.textContent = code;
      if (discountAmountEl) discountAmountEl.textContent = '';
      if (discountMessage) {
        discountMessage.textContent = 'Code will be applied at checkout';
        discountMessage.className = 'cart-drawer__discount-message is-success';
      }
      if (discountApply) {
        discountApply.disabled = false;
        discountApply.textContent = 'Apply';
      }

      // Update checkout link to include discount
      updateCheckoutLink();
    }

    // Remove discount code
    function removeDiscountCode() {
      localStorage.removeItem('moto_discount_code');
      appliedDiscountCode = null;
      if (discountApplied) discountApplied.style.display = 'none';
      if (discountMessage) {
        discountMessage.textContent = '';
        discountMessage.className = 'cart-drawer__discount-message';
      }
      updateCheckoutLink();
    }

    // Update checkout link with discount code
    function updateCheckoutLink() {
      var checkoutLinks = document.querySelectorAll('a[href*="/checkout"]');
      checkoutLinks.forEach(function(link) {
        var baseUrl = '/checkout';
        if (appliedDiscountCode) {
          link.href = baseUrl + '?discount=' + encodeURIComponent(appliedDiscountCode);
        } else {
          link.href = baseUrl;
        }
      });
    }

    // Initialize discount code from localStorage
    if (appliedDiscountCode) {
      if (discountApplied) discountApplied.style.display = 'flex';
      if (discountCodeEl) discountCodeEl.textContent = appliedDiscountCode;
      updateCheckoutLink();
    }

    // Apply button click
    if (discountApply) {
      discountApply.addEventListener('click', function() {
        if (discountInput) applyDiscountCode(discountInput.value);
      });
    }

    // Enter key in input
    if (discountInput) {
      discountInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyDiscountCode(discountInput.value);
        }
      });
    }

    // Remove discount
    if (discountRemove) {
      discountRemove.addEventListener('click', removeDiscountCode);
    }

    window.openCartDrawer = function() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    };

    window.closeCartDrawer = function() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    };

    // Close buttons & overlay
    drawer.querySelectorAll('[data-cart-close]').forEach(function(btn) {
      btn.addEventListener('click', closeCartDrawer);
    });

    // ESC key for cart
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });

    // Cart icon click
    document.querySelectorAll('.header__icon[aria-label="Cart"], .header__cart-icon, [data-cart-toggle]').forEach(function(icon) {
      icon.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      });
    });

    // Format money helper
    function formatMoney(cents) {
      return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // Update cart drawer
    window.updateCartDrawer = function() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          // Update counts
          document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = cart.item_count; });
          document.querySelectorAll('[data-cart-subtotal]').forEach(function(el) { el.textContent = formatMoney(cart.total_price); });
          document.querySelectorAll('.header__cart-count').forEach(function(el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });

          var content = drawer.querySelector('[data-cart-content]');
          var footer = drawer.querySelector('[data-cart-footer]');

          if (cart.item_count === 0) {
            content.innerHTML = '<div class="cart-drawer__empty" data-cart-empty><i class="fa-solid fa-cart-shopping"></i><p>Your cart is empty</p><span>Add some products to get started</span><a href="/collections/all" class="cart-drawer__shop-btn" data-cart-close><span>Start Shopping</span><i class="fa-solid fa-arrow-right"></i></a></div>';
            if (footer) footer.style.display = 'none';
          } else {
            var html = '<div class="cart-drawer__items" data-cart-items>';
            cart.items.forEach(function(item, index) {
              var line = index + 1;
              var imgSrc = item.image ? item.image.replace(/\.([^.]+)$/, '_200x.$1') : '';
              var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
              html += '<div class="cart-drawer__item" data-cart-item data-line="' + line + '" data-variant-id="' + item.variant_id + '" data-title="' + item.product_title.replace(/"/g, '&quot;') + '">';
              html += '<a href="' + item.url + '" class="cart-drawer__item-image">';
              if (imgSrc) {
                html += '<img src="' + imgSrc + '" alt="' + item.product_title + '">';
              } else {
                html += '<div class="cart-drawer__item-placeholder"><i class="fa-solid fa-image"></i></div>';
              }
              html += '</a>';
              html += '<div class="cart-drawer__item-details">';
              html += '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>';
              if (variantTitle) html += '<span class="cart-drawer__item-variant">' + variantTitle + '</span>';
              html += '<div class="cart-drawer__item-price">';
              if (item.original_line_price !== item.final_line_price) {
                html += '<span class="cart-drawer__item-compare">' + formatMoney(item.original_line_price) + '</span>';
              }
              html += '<span class="cart-drawer__item-total">' + formatMoney(item.final_line_price) + '</span>';
              html += '</div>';
              html += '<div class="cart-drawer__item-qty">';
              html += '<button type="button" class="cart-drawer__qty-btn" data-qty-change="-1" aria-label="Decrease"><i class="fa-solid fa-minus"></i></button>';
              html += '<input type="number" class="cart-drawer__qty-input" value="' + item.quantity + '" min="1" max="99" data-qty-input>';
              html += '<button type="button" class="cart-drawer__qty-btn" data-qty-change="1" aria-label="Increase"><i class="fa-solid fa-plus"></i></button>';
              html += '</div></div>';
              html += '<button type="button" class="cart-drawer__item-remove" data-remove-item aria-label="Remove"><i class="fa-solid fa-trash-can"></i></button>';
              html += '</div>';
            });
            html += '</div>';
            content.innerHTML = html;
            if (footer) footer.style.display = 'block';
          }
        });
    };

    // Change quantity
    function changeQuantity(line, quantity) {
      var item = drawer.querySelector('[data-line="' + line + '"]');
      if (item) item.classList.add('is-loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (quantity === 0 && item) {
          item.classList.add('is-removing');
          setTimeout(updateCartDrawer, 300);
        } else {
          updateCartDrawer();
        }
      });
    }

    // Quantity buttons (event delegation)
    drawer.addEventListener('click', function(e) {
      var item = e.target.closest('[data-cart-item]');
      if (!item) return;
      var line = parseInt(item.dataset.line);
      var input = item.querySelector('[data-qty-input]');

      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        var change = parseInt(qtyBtn.dataset.qtyChange);
        var newQty = parseInt(input.value) + change;
        if (newQty >= 1 && newQty <= 99) {
          input.value = newQty;
          qtyBtn.classList.add('is-loading');
          changeQuantity(line, newQty);
        } else if (newQty < 1) {
          var itemTitle = item.dataset.title || 'Item';
          var variantId = item.dataset.variantId;
          qtyBtn.classList.add('is-loading');
          changeQuantity(line, 0);
          if (variantId) showUndoToast(itemTitle, parseInt(variantId));
        }
      }

      var removeBtn = e.target.closest('[data-remove-item]');
      if (removeBtn) {
        removeBtn.classList.add('is-loading');
        changeQuantity(line, 0);
      }
    });

    // Add to cart function
    window.addToCart = function(variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        updateCartDrawer();
        openCartDrawer();
        return item;
      });
    };

    // Quick add form submission (AJAX)
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('.product-card__quick-form');
      if (!form) return;

      e.preventDefault();
      var variantId = form.querySelector('input[name="id"]').value;
      var btn = form.querySelector('.product-card__quick-add');

      if (btn) {
        btn.classList.add('btn-loading');
        btn.disabled = true;
      }

      addToCart(variantId, 1).finally(function() {
        if (btn) {
          btn.classList.remove('btn-loading');
          btn.disabled = false;
        }
      });
    });

    // ===== QUICK VIEW MODAL =====
    var quickView = document.getElementById('quick-view');
    var quickViewContent = quickView ? quickView.querySelector('[data-quick-view-content]') : null;

    window.openQuickView = function(handle) {
      if (!quickView) return;
      quickView.classList.add('is-open');
      quickView.classList.remove('is-loaded');
      document.body.style.overflow = 'hidden';

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          var html = '<div class="quick-view__inner">';
          html += '<div class="quick-view__gallery" data-qv-gallery>';
          html += '<div class="quick-view__image-skeleton"></div>';
          html += '<img src="' + (product.featured_image ? product.featured_image.replace(/\.([^.]+)$/, '_800x.$1') : '') + '" alt="' + product.title + '" class="quick-view__image" data-qv-main-image>';
          if (product.images && product.images.length > 1) {
            html += '<div class="quick-view__thumbs">';
            product.images.slice(0, 5).forEach(function(img, i) {
              html += '<div class="quick-view__thumb ' + (i === 0 ? 'is-active' : '') + '" data-qv-thumb data-image="' + img.replace(/\.([^.]+)$/, '_800x.$1') + '"><img src="' + img.replace(/\.([^.]+)$/, '_100x.$1') + '" alt=""></div>';
            });
            html += '</div>';
          }
          html += '</div>';
          html += '<div class="quick-view__info">';
          if (product.vendor) html += '<span class="quick-view__vendor">' + product.vendor + '</span>';
          html += '<h2 class="quick-view__title">' + product.title + '</h2>';
          html += '<div class="quick-view__price">';
          if (product.compare_at_price && product.compare_at_price > product.price) {
            html += '<span class="quick-view__price-compare">' + formatMoney(product.compare_at_price) + '</span>';
            html += '<span class="quick-view__price-current quick-view__price-current--sale">' + formatMoney(product.price) + '</span>';
          } else {
            html += '<span class="quick-view__price-current">' + formatMoney(product.price) + '</span>';
          }
          html += '</div>';
          if (product.description) {
            var desc = product.description.replace(/<[^>]*>/g, '').substring(0, 300);
            html += '<div class="quick-view__desc">' + desc + (product.description.length > 300 ? '...' : '') + '</div>';
          }
          var selectedVariant = product.variants[0];
          if (product.variants.length > 1 && product.options && product.options.length > 0) {
            html += '<div class="quick-view__variants">';
            product.options.forEach(function(opt, optIndex) {
              var optName = typeof opt === 'string' ? opt : (opt.name || opt);
              html += '<span class="quick-view__variant-label">' + optName + '</span>';
              html += '<div class="quick-view__variant-options">';
              var seen = [];
              product.variants.forEach(function(v) {
                var val = v.options[optIndex];
                if (seen.indexOf(val) === -1) {
                  seen.push(val);
                  html += '<button type="button" class="quick-view__variant-btn ' + (seen.length === 1 ? 'is-active' : '') + '" data-qv-option="' + optIndex + '" data-value="' + val + '">' + val + '</button>';
                }
              });
              html += '</div>';
            });
            html += '</div>';
          }
          html += '<input type="hidden" data-qv-variant-id value="' + selectedVariant.id + '">';
          html += '<div class="quick-view__actions">';
          html += '<button type="button" class="quick-view__atc" data-qv-add-to-cart ' + (!product.available ? 'disabled' : '') + '><i class="fa-solid fa-bag-shopping"></i><span>' + (product.available ? 'Add to Cart' : 'Sold Out') + '</span></button>';
          html += '<a href="/products/' + product.handle + '" class="quick-view__view-link"><span>View Details</span><i class="fa-solid fa-arrow-right"></i></a>';
          html += '</div></div></div>';
          quickViewContent.innerHTML = html;
          quickView.dataset.variants = JSON.stringify(product.variants);
          quickView.classList.add('is-loaded');
        });
    };

    window.closeQuickView = function() {
      if (!quickView) return;
      quickView.classList.remove('is-open', 'is-loaded');
      document.body.style.overflow = '';
      if (quickViewContent) quickViewContent.innerHTML = '';
    };

    // Quick view event listeners
    if (quickView) {
      quickView.querySelectorAll('[data-quick-view-close]').forEach(function(btn) {
        btn.addEventListener('click', closeQuickView);
      });

      quickView.addEventListener('click', function(e) {
        // Thumbnail click
        var thumb = e.target.closest('[data-qv-thumb]');
        if (thumb) {
          var gallery = quickView.querySelector('[data-qv-gallery]');
          var mainImg = quickView.querySelector('[data-qv-main-image]');
          var newUrl = thumb.dataset.image;
          if (mainImg && newUrl && mainImg.src !== newUrl) {
            gallery.classList.add('is-loading');
            mainImg.classList.add('is-loading');
            var preloader = new Image();
            preloader.onload = function() {
              mainImg.src = newUrl;
              mainImg.classList.remove('is-loading');
              gallery.classList.remove('is-loading');
            };
            preloader.onerror = function() {
              mainImg.classList.remove('is-loading');
              gallery.classList.remove('is-loading');
            };
            preloader.src = newUrl;
          }
          quickView.querySelectorAll('[data-qv-thumb]').forEach(function(t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }

        // Add to cart
        if (e.target.closest('[data-qv-add-to-cart]')) {
          var btn = e.target.closest('[data-qv-add-to-cart]');
          var variantId = quickView.querySelector('[data-qv-variant-id]').value;
          btn.classList.add('btn-loading');
          btn.disabled = true;
          addToCart(variantId, 1).then(function() {
            closeQuickView();
          }).finally(function() {
            btn.classList.remove('btn-loading');
            btn.disabled = false;
          });
        }

        // Variant selection
        var optBtn = e.target.closest('[data-qv-option]');
        if (optBtn) {
          optBtn.closest('.quick-view__variant-options').querySelectorAll('.quick-view__variant-btn').forEach(function(b) { b.classList.remove('is-active'); });
          optBtn.classList.add('is-active');
          var variants = JSON.parse(quickView.dataset.variants || '[]');
          var selected = [];
          quickView.querySelectorAll('.quick-view__variant-btn.is-active').forEach(function(b) { selected.push(b.dataset.value); });
          var match = variants.find(function(v) {
            return v.options.every(function(o, i) { return !selected[i] || o === selected[i]; });
          });
          if (match) {
            quickView.querySelector('[data-qv-variant-id]').value = match.id;
            var priceEl = quickView.querySelector('.quick-view__price-current');
            if (priceEl) priceEl.textContent = formatMoney(match.price);
          }
        }
      });
    }

    // Quick view trigger
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quick-view]');
      if (btn) {
        e.preventDefault();
        openQuickView(btn.dataset.quickView);
      }
    });

    // ESC to close quick view
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && quickView && quickView.classList.contains('is-open')) {
        closeQuickView();
      }
    });
  }

  // ===== WISHLIST =====
  var wishlist = JSON.parse(localStorage.getItem('moto_wishlist') || '[]');

  function updateWishlistUI() {
    // Update toggle buttons
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
      var productId = btn.dataset.wishlistToggle;
      if (wishlist.indexOf(productId) > -1) {
        btn.classList.add('is-wishlisted');
        var icon = btn.querySelector('i');
        if (icon) icon.className = 'fa-solid fa-heart';
      } else {
        btn.classList.remove('is-wishlisted');
        var icon = btn.querySelector('i');
        if (icon) icon.className = 'fa-regular fa-heart';
      }
    });

    // Update header wishlist count
    updateWishlistCount();
  }

  function updateWishlistCount() {
    var count = wishlist.length;
    var countEl = document.querySelector('[data-wishlist-count]');
    var iconLink = document.querySelector('[data-wishlist-icon]');

    if (count > 0) {
      if (countEl) {
        countEl.textContent = count;
        countEl.style.display = 'block';
      }
      if (iconLink) {
        iconLink.classList.add('has-items');
        iconLink.style.display = '';
      }
    } else {
      if (countEl) {
        countEl.style.display = 'none';
      }
      if (iconLink) {
        iconLink.classList.remove('has-items');
        iconLink.style.display = 'none';
      }
    }
  }

  function toggleWishlist(productId) {
    var index = wishlist.indexOf(productId);
    if (index > -1) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(productId);
    }
    localStorage.setItem('moto_wishlist', JSON.stringify(wishlist));
    updateWishlistUI();
  }

  // Initialize wishlist UI on page load
  updateWishlistUI();

  // Wishlist toggle click
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault();
      toggleWishlist(btn.dataset.wishlistToggle);
    }
  });

})();
